/* eslint-disable react/prop-types */
import React from 'react';
import { Dropdown, Paragraph } from '@cambridgeassessment/cambridge-ui';
import { Assessment } from '../../../../types/Syllabuses';
import { DropdownContainer } from '../../Content.styles';

interface Props {
  assessments: Assessment[];
  assessment: Assessment;
  onChange: (value: Assessment) => void;
}

const AssessmentVersions: React.FC<Props> = ({ assessments, assessment, onChange }): React.ReactElement => {
  const renderVersion = (assessmentVersion: Assessment): string =>
    `${assessmentVersion.code} (${assessmentVersion.version})`;
  return (
    <>
      <Paragraph data-qa-id='assessment-version-dropdown-title'>
        Multiple versions exist for the selected syllabus. Please select the syllabus version.
      </Paragraph>
      <DropdownContainer>
        <Dropdown<Assessment>
          data={assessments}
          renderOption={renderVersion}
          renderSelectedOption={renderVersion}
          dataQaId='assessment-versions-select'
          onChange={onChange}
          value={assessment}
          placeholder='Please choose a version'
          title='Select version'
        />
      </DropdownContainer>
    </>
  );
};

export default AssessmentVersions;
